var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { createRef } from 'react';
import { Link, Navigate, useNavigate } from 'react-router-dom';
import FormStateStore from 'stores/FormStateStore/store';
import ClientStateStore from 'stores/ClientStateStore/store';
import { login } from 'actions/ServerActionCreators';
import { FormStateSchema } from 'types/formState';
import UniqueId from 'utils/UniqueId';
function getStateFromStores(id) {
    var formState = FormStateStore.getFormState(id);
    return {
        error: formState.state === FormStateSchema.Enum.FAILURE,
        loggedIn: ClientStateStore.isLoggedIn() || false,
        email: ClientStateStore.getClientKey('email') || '',
        formState: formState
    };
}
var AuthCode = /** @class */ (function (_super) {
    __extends(AuthCode, _super);
    function AuthCode(props) {
        var _this = _super.call(this, props) || this;
        _this.UniqueId = UniqueId();
        _this.state = getStateFromStores(_this.UniqueId);
        _this.onChangeHandler = _this.onChangeHandler.bind(_this);
        _this.authCodeRef = createRef();
        _this.handleSubmit = _this.handleSubmit.bind(_this);
        _this.clearErrors = _this.clearErrors.bind(_this);
        return _this;
    }
    AuthCode.prototype.UNSAFE_componentWillMount = function () {
        if (ClientStateStore.isLoggedIn()) {
            this.props.navigate('/');
        }
    };
    AuthCode.prototype.componentDidMount = function () {
        ClientStateStore.addChangeListener(this.onChangeHandler);
        FormStateStore.addChangeListener(this.onChangeHandler);
    };
    AuthCode.prototype.UNSAFE_componentWillUpdate = function (nextProps, nextState) {
        if (nextState.loggedIn) {
            this.props.navigate('/');
        }
    };
    AuthCode.prototype.componentWillUnmount = function () {
        ClientStateStore.removeChangeListener(this.onChangeHandler);
        FormStateStore.removeChangeListener(this.onChangeHandler);
    };
    AuthCode.prototype.handleSubmit = function (e) {
        var _a;
        e.preventDefault();
        var data = {
            auth_code: ((_a = this.authCodeRef.current) === null || _a === void 0 ? void 0 : _a.value) || '',
            email: this.state.email
        };
        login(data, this.UniqueId);
    };
    AuthCode.prototype.onChangeHandler = function () {
        this.setState(getStateFromStores(this.UniqueId));
    };
    AuthCode.prototype.getErrorMessage = function () {
        if (!this.state.error) {
            return '';
        }
        return (_jsx("div", { className: "ui-message-container--error", children: _jsxs("div", { className: "ui-message-body", children: [_jsx("i", { className: "icon ion-information-circled ui-message-icon" }), _jsx("span", { className: "ui-message-text", children: "Invalid code." })] }) }));
    };
    AuthCode.prototype.clearErrors = function () {
        this.setState({ error: false });
    };
    AuthCode.prototype.render = function () {
        var submitText = this.state.formState.state === FormStateSchema.Enum.LOADING ? 'Loading...' : 'Log In';
        if (ClientStateStore.isLoggedIn()) {
            return _jsx(Navigate, { to: "/" });
        }
        return (_jsxs("div", { children: [_jsx("div", { className: "sb-app-header", children: _jsx("img", { className: "sb-app-logo", src: "/img/mobile/logo_black.svg", alt: "ScoreboardBuzz" }) }), _jsxs("div", { className: "centered-panel", children: [_jsxs("form", { onSubmit: this.handleSubmit, children: [_jsx("header", { className: "centered-panel-header", children: _jsx("span", { className: "centered-panel-header-title", children: "Log in" }) }), _jsx("p", { className: "text-center", children: "An authentication code was sent to your email" }), _jsx("br", {}), this.getErrorMessage(), _jsx("fieldset", { className: "fieldset", children: _jsx("input", { type: "text", className: "field focus-first", id: "authCode", required: true, placeholder: "Enter your authentication code", onChange: this.clearErrors, ref: this.authCodeRef }) }), _jsx("fieldset", { className: "fieldset text-center pad-top pad-bottom push-bottom", children: _jsx("button", { type: "submit", id: "FakeLogin", className: "button--main", children: submitText }) })] }), _jsxs("p", { className: "pad-top text-center no-layout", children: [_jsx(Link, { to: "/login", className: "button--link button--sm", children: "Get A New Code" }), _jsx("br", {}), _jsx("a", { href: "/register", className: "button--link button--sm", children: "Create an account" }), _jsx("br", {}), _jsx("a", { href: "/", className: "button--link button--sm", children: "Full website" })] })] })] }));
    };
    return AuthCode;
}(React.Component));
var AuthCodeWrapper = function (props) {
    var navigate = useNavigate();
    // eslint-disable-next-line react/jsx-props-no-spreading
    return _jsx(AuthCode, __assign({}, props, { navigate: navigate }));
};
export default AuthCodeWrapper;
